import packageJson from '../../package.json';

const {
  REACT_APP_FIREBASE_API_KEY,
  REACT_APP_FIREBASE_AUTH_DOMAIN,
  REACT_APP_FIREBASE_DATABASE_URL,
  REACT_APP_FIREBASE_PROJECT_ID,
  REACT_APP_FIREBASE_STORAGE_BUCKET,
  REACT_APP_FIREBASE_MESSAGE_SENDER_ID,
  REACT_APP_FIREBASE_APP_ID,
  REACT_APP_FIREBASE_MEASUREMENT_ID,
  REACT_APP_IPINFO_TOKEN,
  REACT_APP_CALENDLY_API_TOKEN,
  REACT_APP_ENV,
} = process.env;

export const GDP_SIGNUP_FORM_STEPS = 4;
export const DESIGNER_SIGNUP_FORM_STEPS = 2;
export const SPECIALIST_SIGNUP_FORM_STEPS = 2;
export const IPINFO_TOKEN = REACT_APP_IPINFO_TOKEN;
export const CALENDLY_API_TOKEN = REACT_APP_CALENDLY_API_TOKEN;
export const APP_ENV = REACT_APP_ENV || 'dev';
export const APP_VERSION = packageJson.version;
export const USER_ROLES = {
  DENTIST: 'dentist',
  DESIGNER: 'designer',
  SPECIALIST: 'specialist',
  MANUFACTURER: 'manufacturer',
  ADMIN: 'admin',
};

export const DENTAL_SCHOOL_LIST = [
  'Aberdeen',
  'Belfast',
  'Bristol',
  'Birmingham',
  'Cardiff',
  'Dundee',
  'Glasgow',
  'Leeds',
  'Liverpool',
  'London Kings',
  'London Barts',
  'Manchester',
  'Newcastle',
  'Plymouth',
  'Preston',
  'Sheffield',
  'Other',
];

export const FIREBASE_CONFIG = {
  apiKey: REACT_APP_FIREBASE_API_KEY,
  authDomain: REACT_APP_FIREBASE_AUTH_DOMAIN,
  storageBucket: REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: REACT_APP_FIREBASE_MESSAGE_SENDER_ID,
  appId: REACT_APP_FIREBASE_APP_ID,
  measurementId: REACT_APP_FIREBASE_MEASUREMENT_ID,
  projectId: REACT_APP_FIREBASE_PROJECT_ID,
  databaseURL: REACT_APP_FIREBASE_DATABASE_URL,
};
export const UK_PHONE_NUMBER_REGEX =
  /\s*(([+](\s?\d)([-\s]?\d)|0)?(\s?\d)([-\s]?\d){9}|[(](\s?\d)([-\s]?\d)+\s*[)]([-\s]?\d)+)\s*/;
export const US_PHONE_NUMBER_REGEX = /^\(?([0-9]{3})\)?[-.●]?([0-9]{3})[-.●]?([0-9]{4})$/;
export const IN_PHONE_NUMBER_REGEX = /^[6-9]{1}[0-9]{9}$/;
export const TUR_PHONE_NUMBER_REGEX =
  /\s*(([+](\s?\d)([-\s]?\d)|0)?(\s?\d)([-\s]?\d){9}|[(](\s?\d)([-\s]?\d)+\s*[)]([-\s]?\d)+)\s*/;

export enum CaseTypeEnum {
  DUO = 'duo',
  SOLO = 'solo',
}
// used for showing text purpose on Frontend because API responses still uses old key
export const CASE_TYPE_TO_UI_CONVERTER: Record<string, string> = {
  lite: CaseTypeEnum.SOLO,
  pro: CaseTypeEnum.DUO,
};

// replaced pro/lite by duo/solo on Frontend already but Backend still use the old key
// that why need below mapping to get API KEY
export const CASE_TYPE_TO_API_CONVERTER: Record<CaseTypeEnum, 'pro' | 'lite'> = {
  [CaseTypeEnum.SOLO]: 'lite',
  [CaseTypeEnum.DUO]: 'pro',
};
